import ShirtsAndTops from "./ShirtsAndTops";

function Kids(){
    return(
        <div>
            <ShirtsAndTops/>
        </div>
    )
}
export default Kids;